import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Checkbox, Grid, Input } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchAcademicYears, fetchStudentStatuses,
    fetchStudyCycle,
    fetchStudyType, fetchStudyYears,
} from '../../Lookups/util';

import ReactExport from 'react-data-export';
import ReportExcelFile from './ReportExcelFile';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";
import {
    filterFieldGridStyle,
    requiredFilterSectionStyle
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class EnrolledStudentsPerStudyYearAndStudyTypeForFaculty extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstTimeEnrolled: false,
            moreThanOnceEnrolled: false,
            studyCycleId: null,
            studyTypeId: null,
            studyYearId: null,
            studentStatusId: null,
            studyProgramSemesterId: null,
            studyProgramBasicId: null,
            semesterId: null,
            organizationalUnitId: null,
            academicYearId: null,

            studyCycles: [],
            studyTypes: [],
            studentStatuses: [],
            studyProgramBasics: [],
            studyProgramBasicsAll: [],
            studyYears: [],
            studyProgramSemesters: [],
            studyProgramSemestersAll: [],

            semesters: [],
            academicYears: [],

            stats: [],
            loaded: null,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData: [],
            exactNumberOfEnrollments: null,

            unsa: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourseImplementationsByAcademicYear = this.getCourseImplementationsByAcademicYear.bind(this);
    }

    getCourseImplementationsByAcademicYear(semesterId) {
        axios.get(
            // (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            // `study-programs/basic/${localStorage.getItem('orgUnit')}`
            // :
            'course/filter-implementations/', { params: { semesterId, academicYearId: null } })
            .then(res => {
                const courseImplementations = res.data.map((el) => ({
                    ...el,
                    value: el.id,
                    key: el.courseBasic.id,
                    text: el.courseBasic.name + (el.comment !== null ? ' (' + el.comment + ')' : ''),
                    description: el.courseBasic.comment
                }))

                this.setState({ courseImplementations });
            })
            .catch(err => {
                console.log('Failed to fetch course implementations. ', err);
            });
    }
    componentDidMount() {
        let obj = {};
        axios.post(this.state.unsa ? 'study-programs/basic/all' : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.unsa ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                console.log('studyProgramBasics', studyProgramBasics);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.get('/study-program-semesters')
            .then(res => {
                let studyProgramSemesters = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    studyProgramSemesters, studyProgramSemestersAll: studyProgramSemesters
                });
            });

        axios.all([fetchAcademicYears(), fetchStudyCycle(), fetchStudyType(), fetchStudentStatuses(), fetchStudyYears()])
            .then(axios.spread((yearsRes, studyCycleRes, studyTypesRes, studentStatusesRes, studyYearsRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                const studyTypes = studyTypesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));


                let studentStatuses = studentStatusesRes.data.filter(e => e._key == 'regular' || e._key == 'exchange' || e._key == 'guest' || e._key == 'grad_again').map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const studyYears = studyYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    studyCycles, studyTypes, studentStatuses, studyYears, academicYears
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });

        if (name === 'academicYearId') {
            console.log('SELECTED ACADEMIC YEAR', value);
            axios.get(`semester/by-academic-year/${value}`)
                .then(res => {
                    this.setState({
                        semesters: res.data.filter(e => e.name.name !== 'ostalo' && e.name.name !== 'ljetna škola').map(el => ({
                            ...el, key: el.id, value: el.id, text: el.name.name
                        }))
                    });
                });
        }

        if (name === 'semester' && value !== null) {
            console.log('SELECTED SEMESTER', value);
            this.getCourseImplementationsByAcademicYear(value)
        }

        if (name === 'studyCycleId') {
            console.log('SELECTED STUDY CYCLE', value);
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }

        if (name === 'studyYearId') {
            if (value === null) this.setState({ studyProgramSemesters: this.state.studyProgramSemesters });
            axios.get('/study-program-semesters')
                .then(res => {
                    this.setState({
                        studyProgramSemesters: this.state.studyProgramSemestersAll.filter(e => e.studyYear.id === value)
                    });
                });
        }
        if (name === 'studyCycleId' && value === '') { this.setState({ studyCycleId: null, studyProgramBasics: this.state.studyProgramBasicsAll }); }
        if (name === 'studyYearId' && value === '') { this.setState({ studyYearId: null, studyProgramSemesters: this.state.studyProgramSemestersAll }); }
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });

        /*
        let obj = {
            firstTimeEnrolled: this.state.firstTimeEnrolled,
            moreThanOnceEnrolled: this.state.moreThanOnceEnrolled,
            studyCycleId: this.state.studyCycleId,
            studyTypeId: this.state.studyTypeId,
            studyYearId: this.state.studyYearId,
            studentStatusId: this.state.studentStatusId,
            studyProgramSemesterId: this.state.studyProgramSemesterId,
            studyProgramBasicId: this.state.studyProgramBasicId,
            exactNumberOfEnrollments: this.state.exactNumberOfEnrollments === '' ? null :  this.state.exactNumberOfEnrollments
        };
        */

        /*
            axios.post(`/reports/enrolled-in-course-implementation/${this.state.courseImplementationId}/`, { ...obj })
                .then(res => {
                    console.log('res', res.data);
                    this.setState({
                        students: res.data.map(el => ({ ...el, department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : '' })), loaded: true,
                        excelData:  res.data.map(el => ([
                            { value: el.lastName},
                            { value: el.firstName},
                            { value: el.fatherName ? el.fatherName : ''},
                            { value: el.index ? el.index : ''},
                            { value: el.studyCycleName},
                            { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                            { value: el.studyProgramBasicName},
                            { value: el.studyProgramName},
                            { value: el.studyYearName},
                            { value: el.studyProgramSemesterName},
                            { value: el.studyTypeName},
                            { value: el.studentStatusName},
                        ]))
                    });
                });
        */

        console.log('semester', this.state.semester);
        console.log('studyCycleId', this.state.studyCycleId);
        axios.post(`reports/enrolled-per-study-year-and-study-type-for-university/${this.state.studyCycleId}/${this.state.semester}`).then(res => {
            console.log('res', res.data);
            this.setState({
                stats: res.data,
                excelData: res.data.map(el => ([
                    { value: el.faculty ? el.faculty : 'NULL' },
                    { value: el.year ? el.year : 'NULL' },
                    { value: el.fullTime ? el.fullTime : 0 },
                    { value: el.partTime ? el.partTime : 0 },
                    { value: el.fullTimeSelfFinanced ? el.fullTimeSelfFinanced : 0 },
                    { value: el.distanceLearning ? el.distanceLearning : 0 },
                    { value: el.parallel ? el.parallel : 0 },
                    { value: el.withoutStudyType ? el.withoutStudyType : 0 },
                    { value: el.numberOfStudents ? el.numberOfStudents : 0 },
                ])),
                loaded: true
            })
        }).catch(err => {
            console.log('Failed to fetch students. ', err);
        });;
    }

    getResults(results) {
        if (results.length === 0) {
            this.setState({
                excelData:
                    // this.state.unsa ?
                    // this.state.students.map(el => ([
                    //     { value: el.organizationalUnitName},
                    //     { value: el.numberOfStudents},
                    // ]))
                    // :
                    this.state.stats.map(el => ([
                        { value: el.faculty },
                        { value: el.year },
                        { value: el.fullTime },
                        { value: el.partTime },
                        { value: el.fullTimeSelfFinanced },
                        { value: el.distanceLearning },
                        { value: el.parallel },
                        { value: el.withoutStudyType },
                        { value: el.numberOfStudents },
                    ]))
            });
        }
        else {
            this.setState({
                results,
                excelData:
                    // this.state.unsa ?
                    // results.map(el => ([
                    //     { value: el.organizationalUnitName},
                    //     { value: el.numberOfStudents},
                    // ]))
                    // :
                    results.map(el => ([
                        { value: el.faculty },
                        { value: el.year },
                        { value: el.fullTime },
                        { value: el.partTime },
                        { value: el.fullTimeSelfFinanced },
                        { value: el.distanceLearning },
                        { value: el.parallel },
                        { value: el.withoutStudyType },
                        { value: el.numberOfStudents },
                    ]))
            });
        }
        this.handlePaginationChange({}, { activePage: 1 })
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.stats;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {

        const numberOfEnrollments = [
            { key: 2, text: '2', value: 2 },
            { key: 3, text: '3', value: 3 },
            { key: 4, text: '4', value: 4 },
            { key: 5, text: '5', value: 5 },
            { key: 6, text: '6', value: 6 },
            { key: 7, text: '7', value: 7 },
            { key: 8, text: '8', value: 8 },
            { key: 9, text: '9', value: 9 },
            { key: 10, text: '10', value: 10 },
        ]

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Fakultet', width: { wpx: 300 } },
                    { title: 'Godina', width: { wpx: 100 } },
                    { title: 'Redovan', width: { wpx: 100 } },
                    { title: 'Vanredan', width: { wpx: 100 } },
                    { title: 'Redovni-samofinansirajući', width: { wpx: 100 } },
                    { title: 'DL', width: { wpx: 100 } },
                    { title: 'Paralelni', width: { wpx: 100 } },
                    { title: 'Bez tipa studija', width: { wpx: 120 } },
                    { title: 'Ukupno', width: { wpx: 100 } },
                ],
                data: this.state.excelData,
            }
        ];

        /*
        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Organizaciona jedinica', width: { wpx: 0 } },
                    { title: 'Broj studenata', width: { wpx: 0 } },
                ],
                data: this.state.excelData,
            }
        ];
        */

        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                            <Form.Field>
                                <Form.Dropdown
                                    label="Akademska godina"
                                    clearable={this.get}
                                    placeholder="Odaberite akademsku godinu"
                                    value={this.state.academicYearId}
                                    onChange={this.handleInputChange}
                                    name="academicYearId"
                                    options={this.state.academicYears}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>

                            <Form.Field>
                                <Form.Dropdown
                                    label="Semestar"
                                    disabled={!this.state.academicYearId}
                                    placeholder="Odaberite semestar"
                                    options={this.state.semesters}
                                    onChange={this.handleInputChange}
                                    name="semester"
                                    value={this.state.semester}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    label="Ciklus studija"
                                    disabled={!this.state.semester}
                                    clearable
                                    placeholder="Odaberite ciklus"
                                    options={this.state.studyCycles}
                                    onChange={this.handleInputChange}
                                    name="studyCycleId"
                                    value={this.state.studyCycleId}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                        </Form.Group>
                    </Segment>

                    <Button disabled={!this.state.studyCycleId} basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button disabled={!this.state.studyCycleId} color="blue" floated="right" onClick={this.filter}>Prikaži izvještaj
                    </Button>

                </Form>
                <br /><br /><br />
                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.stats.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={20} >
                                        <Grid stackable >
                                            <Grid.Column width={14} >
                                                <SearchTableData profMozilla data={this.state.stats} getResults={this.getResults} filterItem={[
                                                    { name: 'faculty', type: 'text' },
                                                ]} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="right">
                                                <ExcelFile filename="Upisani studenti" element={<Popup
                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}>
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}> Fakultet </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Godina </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Redovan </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Vanredan </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Redovni-samofinansirajući </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> DL </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Paralelni </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Bez tipa studija </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Ukupno </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                            (<Table.Row key={el.id}>

                                <Table.Cell verticalAlign="middle" width="1">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                                <Table.Cell colSpan={3} verticalAlign="middle" > {el.faculty}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.year}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.fullTime}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.partTime}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.fullTimeSelfFinanced}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.distanceLearning}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.parallel}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.withoutStudyType}</Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle" > {el.numberOfStudents}</Table.Cell>
                            </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}

export default EnrolledStudentsPerStudyYearAndStudyTypeForFaculty;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/EnrolledStudentsPerStudyYearAndStudyTypeForFaculty.js